export const HOME_ROUTE = "/";
export const ABOUT_US_ROUTE = "/about-us";
export const SERVICES_ROUTE = "/services";
export const RESOURCES_ROUTE = "/resources";
export const KEY_PERSONNEL_ROUTE = "/key-personnel";
export const CONTACT_US_ROUTE = "/contact-us";
